import { createContext } from 'react';

export const LinkContext = createContext(0);
